import React from 'react';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {Row, Col} from 'react-bootstrap';
import TicketsCountBox from './TicketsCountBox';


@injectIntl @inject('analyticsStore') @observer
export default class GeneralTicketsStatistics extends React.Component{
    render(){
        const {intl, analyticsStore} = this.props;
        return(
            <Row>
                <Col xs={6} md={3}>
                    <TicketsCountBox
                        count={analyticsStore.totalNewTickets}
                        description={intl.formatMessage({id: 'total_new_tickets_label'})} />
                </Col>
                <Col xs={6} md={3}>
                    <TicketsCountBox
                        count={analyticsStore.totalSolvedTickets}
                        description={intl.formatMessage({id: 'total_solved_tickets_label'})} />
                </Col>
                <Col xs={6} md={3}>
                    <TicketsCountBox
                        count={analyticsStore.totalUnsolvedTickets}
                        description={intl.formatMessage({id: 'total_unsolved_tickets_label'})} />
                </Col>
                <Col xs={6} md={3}>
                    <TicketsCountBox
                        count={analyticsStore.averageComments}
                        description={intl.formatMessage({id: 'average_comments_label'})} />
                </Col>
            </Row>
        );
    }
};